import {Paper, Slide} from "@mui/material";
import Box from "@mui/material/Box";
import {Info} from "@mui/icons-material";
import Typography from "@mui/material/Typography";

export default function () {
    return (
        <Slide direction={"left"} in={true} timeout={750}>
            <Paper elevation={3}>
                <Box display="flex" alignItems={"center"} px={2} py={1}>
                    <Box display="flex" alignItems={"center"}>
                        <Info color={"warning"}/>
                    </Box>
                    <Box ml={1}>
                        <Typography display={"inline"}>
                            Vous avez&nbsp;
                        </Typography>
                        <Typography display="inline" fontWeight={"bold"} color={"warning"}>
                            3 heures&nbsp;
                        </Typography>
                        <Typography display="inline">
                            pour aller chez le sociétaire.
                        </Typography>
                    </Box>
                </Box>
            </Paper>
        </Slide>
    )
}